import React, { FC, Suspense } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import ReactPlayer from "react-player";

export const ChatText: FC<{ isMe: boolean; text: string }> = ({
  isMe,
  text,
}) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const urls = text.match(urlRegex) || [];
  const videoUrl = urls.filter((url) => {
    return ReactPlayer.canPlay && ReactPlayer.canPlay(url);
  });

  return (
    <Box>
      <Typography
        variant="body2"
        sx={(theme) => ({
          color: isMe
            ? theme.palette.getContrastText(theme.palette.primary.main)
            : "inherit",
        })}
      >
        {text}
      </Typography>
      {videoUrl.map((url, index) => (
        <Box
          key={`video-${url}-${index}`}
          sx={{
            width: "100%",
            overflow: "hidden",
            mb: videoUrl.length > 1 && index < videoUrl.length - 1 ? 1 : 0,
          }}
        >
          <Suspense fallback={<LinearProgress />}>
            <ReactPlayer
              src={url}
              controls
              style={{ width: "100%", height: "auto", aspectRatio: "16/9" }}
            />
          </Suspense>
        </Box>
      ))}
    </Box>
  );
};
